import { decryptWithApiKey, decodePlaintextContent } from './aes-gcm'

/** Decrypt a share blob based on its cipher type. Returns null if decryption isn't possible. */
export async function decryptShareBlob(
  blob: string,
  meta: { cipher: string; wrappedCekApiKey?: string | null; kdfSaltApiKey?: string | null; nonce?: string | null },
  apiKey: string,
): Promise<string | null> {
  if (meta.cipher === 'NONE') {
    return decodePlaintextContent(blob)
  }
  if (meta.wrappedCekApiKey && meta.kdfSaltApiKey && meta.nonce) {
    return await decryptWithApiKey(blob, meta.wrappedCekApiKey, meta.nonce, meta.kdfSaltApiKey, apiKey)
  }
  return null
}
